import { Base } from "./../../framework/base";
import { ListItems } from "./../../framework/listItems";
import { IWhistleBlowCategoryListItem, WhistleBlowCategoryListItem } from "./whistleBlowCategoryListItem";

export interface IWhistleBlowCategoryListItems extends ListItems<IWhistleBlowCategoryListItem> { }

export class WhistleBlowCategoryListItems extends ListItems<WhistleBlowCategoryListItem> implements IWhistleBlowCategoryListItems {
    constructor();
    constructor(obj: IWhistleBlowCategoryListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray<WhistleBlowCategoryListItem>(obj ? obj.items : null, WhistleBlowCategoryListItem);
    }
}